<div fxFlex.lt-sm="100%" fxFlex="100%">
	<div
		fxLayout="row wrap"
		fxLayout.xs="column"
		fxLayoutAlign="space-between baseline"
	>
		<h2
			i18n="@@paymentRequest_makeAPaymentRequest_title"
			*ngIf="componentCalled != 'share-dialog'"
		>
			Make a Payment request
		</h2>
		<mat-icon *ngIf="isLoading">
			<mat-spinner color="accent" diameter="16"></mat-spinner>
		</mat-icon>
	</div>
	<div>
		<form [formGroup]="paymentForm">
			<div
				fxLayout="row"
				fxLayoutGap.xs="2%"
				fxLayoutGap.lg="2%"
				fxLayoutGap.lt-md="2%"
				fxLayoutGap.lt-sm="2%"
				fxLayoutGap.lt-lg="2%"
				fxLayoutGap.gt-lg="2%"
				fxLayoutAlign="space-between center"
				class="customFormField"
			>
				<mat-form-field fxFlex="60%" appearance="outline" floatLabel="always">
					<mat-label i18n="@@paymentRequest_enterAmount_title"
						>Enter Amount</mat-label
					>
					<div fxLayout="column" matPrefix class="custom-p" ngClass="p-r-m">
						<div fxLayout="row" fxLayoutAlign="center">
							<p>&nbsp;{{ currency_symbol }}&nbsp;</p>
						</div>
						<div fxLayout="row">
							<p>&nbsp;{{ currency | uppercase }}&nbsp;</p>
						</div>
					</div>
					<input
						required
						formControlName="otherAmountInput"
						i18n="@@paymentRequest_enterAmount_title"
						matInput
						type="number"
						name="otherAmount"
						class="right-align"
						[(ngModel)]="otherAmount"
						(ngModelChange)="updateSelectedAmount($event)"
						id="customDonationAmountInput"
					/>
					<mat-error
						*ngIf="paymentForm.hasError('required', 'otherAmountInput')"
						i18n="@@payment_request_shareFundraiser_donationAmountRequired"
					>
						Please enter the donation amount
					</mat-error>
					<mat-error *ngIf="paymentForm.hasError('min', 'otherAmountInput')">
						<span i18n="@@payment_request_shareFundraiser_donationAmountMinimum"
							>Minimum donation amount is</span
						>&nbsp; {{ this.currency_symbol }}{{ min_donation_amount }}
					</mat-error>
					<mat-error *ngIf="paymentForm.hasError('max', 'otherAmountInput')">
						<span i18n="@@payment_request_shareFundraiser_donationAmountMaximum"
							>Maximum donation amount is</span
						>&nbsp; {{ this.currency_symbol }}{{ max_donation_amount }}
					</mat-error>
					<!-- (click)="getOtherValue(input.value)" -->
				</mat-form-field>
				<div fxFlex="40%" class="p-b-xs">
					<button
						fxLayout.xs="row wrap"
						id="preset-button"
						mat-flat-button
						color="accent"
						(click)="getPreset()"
						i18n="@@button_save"
						[disabled]="
							!otherAmount ||
							otherAmount < min_donation_amount ||
							otherAmount > max_donation_amount
						"
					>
						Save
					</button>
				</div>
			</div>
		</form>

		<div *ngIf="componentCalled === 'share-dialog'" fxLayout="column">
			<span i18n="@@share_dialog_step2"> Step 2 </span>
			<h2 i18n="@@share_dialog_select_where_to_share">
				Select where you want to share
			</h2>
		</div>

		<!-- <mat-divider></mat-divider> -->
		<app-share-fundraiser-page
			[type]="'paymentRequest'"
			[preview]="true"
			[disablePayment]="currentPaymentValue"
			[applyPadding]="true"
		>
		</app-share-fundraiser-page>
	</div>
</div>
